import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-back-header',
  imports: [CommonModule, MatIconModule, MatButtonModule, RouterModule],
  templateUrl: './back-header.component.html',
  styleUrl: './back-header.component.scss',
  standalone: true,
})
export class BackHeaderComponent {
  @Input() backLink?: string; // Make it optional
  @Input() headerText: string = '';
  @Output() backAction = new EventEmitter<void>();

  handleClick() {
    if (this.backAction.observed) {
      // If parent is listening to backAction, emit the event
      this.backAction.emit();
      event?.preventDefault(); // Prevent navigation if function is handled
    }
    // If no backAction listener, routerLink will handle navigation
  }
}
